
import {
    DEX_LOADING,
    DEX_LOADED,
    DEX_ERROR, 

    CREAR_ITEM_DEX_LOADING,
    CREAR_ITEM_DEX_LOADED,
    CREAR_ITEM_DEX_ERROR,

    EDITAR_DEX_ITEM_LOADING,
    EDITAR_DEX_ITEM_LOADED,
    EDITAR_DEX_ITEM_ERROR, 

    DELETE_ITEM_DEX_LOADING,
    DELETE_ITEM_DEX_LOADED,
    DELETE_ITEM_DEX_ERROR,

    CREAR_DEX_LOADING,
    CREAR_DEX_LOADED,
    CREAR_DEX_ERROR,

    EDITAR_DEX_LOADING,
    EDITAR_DEX_LOADED,
    EDITAR_DEX_ERROR,

    DEX_ITEM_LOADING,
    DEX_ITEM_LOADED,
    DEX_ITEM_ERROR, 

    DEX_UBICACIONES_LOADING,
    DEX_UBICACIONES_LOADED,
    DEX_UBICACIONES_ERROR,

    DEX_LOADING_HOME,
    DEX_LOADED_HOME,
    DEX_ERROR_HOME,

    DEX_LOADING_HOME_SLIDER,
    DEX_LOADED_HOME_SLIDER,
    DEX_ERROR_HOME_SLIDER,
    DEX_REFRESH_HOME_SLIDER,

    RESET_CREAR_DEX,
    RESET_EDITAR_DEX,

    DEX_LOADING_DETAIL_HOME,
    DEX_LOADED_DETAIL_HOME,
    DEX_ERROR_DETAIL_HOME,

    UNIRSE_DEX_LOADING,
    UNISER_DEX_LOADED,
    UNIRSE_DEX_ERROR,

  } from '../../types/dex';

const INITIAL_STATE = {
    dexUnirse: [],
    dexUnirseLoading: false,
    dexUnirseLoaded: false,
    dexUnirseError: '',

    dexData: [],
    dexLoading: false,
    dexLoaded: false,
    dexError: '',

    dexHomeLoading: false,
    dexHomeLoaded: false,
    dexHomeData:[],
    dexHomeError: '',

    dexHomeSliderPages: {},
    dexHomeSliderData:[],
    dexHomeSliderLoading: false,
    dexHomeSliderError: '',
    dexHomeSliderLoaded: false,

    crearDexData: [],
    crearDexLoading: false,
    crearDexLoaded: false,
    crearDexError: '',

    editarDexData: [],
    editarDexLoading: false,
    editarDexLoaded: false,
    editarDexError: '',

    crearDexitemData: [],
    crearDexitemLoading: false,
    crearDexitemLoaded: false,
    crearDexitemError: '',

    deleteDexitemData: [],
    deleteDexitemLoading: false,
    deleteDexitemLoaded: false,
    deleteDexitemError: '',

    editarDexitemData: [],
    editarDexitemLoading: false,
    editarDexitemLoaded: false,
    editarDexitemError: '',

    dexItem: [],
    dexItemLoading: false,
    dexItemLoaded: false,
    dexItemError: '',

    dexUbicaciones: [],
    dexUbicacionesLoading: false,
    dexUbicacionesLoaded: false,
    dexUbicacionesError: '',

    dexHomeDetailLoading: false,
    dexHomeDetailLoaded: false,
    dexHomeDetailData: [],
    dexHomeDetailError: '',

    usersdexLoading: false,
    usersdexLoaded: false,
    usersdexError: "",
    usersdexData: [],  
    count: 0,      
    currentPage: 1,    
    currentSearch: "",  
    currentDexId: null, 

};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case UNIRSE_DEX_LOADING:
            return {
                ... state,
                dexUnirseLoading: true,
                dexUnirseLoaded: false,
                dexUnirse: [],
                dexUnirseError: '',
            }
        // case UNISER_DEX_LOADED:
        //     return {
        //         ...state,
        //         dexUnirseLoading: false,
        //         dexUnirseLoaded: true,
        //         dexUnirse: action.payload,
        //         dexUnirseError: '',
                
        //         dexHomeDetailData: {
        //             ...state.dexHomeDetailData,
        //             pertenece_dex: action.payload.pertenece_dex,
        //             rol_usuario_dex: action.payload.rol_usuario_dex,
        //         }
        //     };

        case UNISER_DEX_LOADED: {
            const { dex_id, pertenece_dex, rol_usuario_dex } = action.payload;

            // Clonamos pages (nivel 1)
            const updatedPages = { ...state.dexHomeSliderPages };

            // Recorremos páginas
            Object.keys(updatedPages).forEach((pageKey) => {
                const pageData = updatedPages[pageKey];

                if (!pageData?.results) return;

                const index = pageData.results.findIndex(d => d.id === dex_id);

                if (index !== -1) {
                    // 🔥 IMPORTANTE: crear NUEVAS referencias
                    const updatedResults = [...pageData.results];

                    updatedResults[index] = {
                        ...updatedResults[index],
                        pertenece_dex,
                        rol_usuario_dex,
                    };

                    updatedPages[pageKey] = {
                        ...pageData,
                        results: updatedResults,
                    };
                }
            });

            return {
                ...state,
                dexUnirseLoading: false,
                dexUnirseLoaded: true,
                dexUnirse: action.payload,
                dexUnirseError: '',

                // 🔹 detalle (opcional, ya lo tenías)
                dexHomeDetailData: {
                    ...state.dexHomeDetailData,
                    pertenece_dex,
                    rol_usuario_dex,
                },

                // 🔥 ESTO es lo que tu componente usa
                dexHomeSliderPages: updatedPages,
            };
        }

        case UNIRSE_DEX_ERROR:
            return {
                ...state,
                dexUnirseLoading: false,
                dexUnirseLoaded: false,
                dexUnirse:[],
                dexUnirseError: action.payload,
            }

        case RESET_CREAR_DEX:
            return {
                ...state,
                crearDexLoading: false,
                crearDexLoaded: false,
                crearDexData: [],
                crearDexError: '',
            };
        case RESET_EDITAR_DEX:
            return {
                ...state,
                editarDexLoading: false,
                editarDexLoaded: false,
                editarDexData: [],
                editarDexError: '',
            };

        case DELETE_ITEM_DEX_LOADING:
            return {
                ... state,
                deleteDexitemLoading: true,
                deleteDexitemLoaded: false,
                deleteDexitemData: [],
                deleteDexitemError: '',
            }
        case DELETE_ITEM_DEX_LOADED:
            return {
                ...state,
                deleteDexitemLoading: false,
                deleteDexitemLoaded: true,
                deleteDexitemData: action.payload,
                deleteDexitemError: '',
            };
        case DELETE_ITEM_DEX_ERROR:
            return {
                ...state,
                deleteDexitemLoading: false,
                deleteDexitemLoaded: false,
                deleteDexitemData:[],
                deleteDexitemError: action.payload,
            }

        case EDITAR_DEX_ITEM_LOADING:
            return {
                ... state,
                editarDexitemLoading: true,
                editarDexitemLoaded: false,
                editarDexitemData: [],
                editarDexitemError: '',
            }
        case EDITAR_DEX_ITEM_LOADED:
            return {
                ...state,
                editarDexitemLoading: false,
                editarDexitemLoaded: true,
                editarDexitemData: action.payload,
                editarDexitemError: '',
            };
        case EDITAR_DEX_ITEM_ERROR:
            return {
                ...state,
                editarDexitemLoading: false,
                editarDexitemLoaded: false,
                editarDexitemData:[],
                editarDexitemError: action.payload,
            }

        case EDITAR_DEX_LOADING:
            return {
                ... state,
                editarDexLoading: true,
                editarDexLoaded: false,
                editarDexData: [],
                editarDexError: '',
            }
        case EDITAR_DEX_LOADED:
            return {
                ...state,
                editarDexLoading: false,
                editarDexLoaded: true,
                editarDexData: action.payload,
                dexItem: {
                    ...state.dexItem,
                    esp_comun: action.payload.esp_comun || state.dexItem?.esp_comun || [],
                    esp_pococomun: action.payload.esp_pococomun || state.dexItem?.esp_pococomun || [],
                    esp_raro: action.payload.esp_raro || state.dexItem?.esp_raro || [],
                },
                editarDexError: '',
            };
        case EDITAR_DEX_ERROR:
            return {
                ...state,
                editarDexLoading: false,
                editarDexLoaded: false,
                editarDexData:[],
                editarDexError: action.payload,
            }

        case CREAR_DEX_LOADING:
            return {
                ... state,
                crearDexLoading: true,
                crearDexLoaded: false,
                crearDexData: [],
                crearDexError: '',
            }
        case CREAR_DEX_LOADED:
            return {
                ...state,
                crearDexLoading: false,
                crearDexLoaded: true,
                crearDexData: action.payload,
                crearDexError: '',
            };
        case CREAR_DEX_ERROR:
            return {
                ...state,
                crearDexLoading: false,
                crearDexLoaded: false,
                crearDexData:[],
                crearDexError: action.payload,
            }

        case CREAR_ITEM_DEX_LOADING:
            return {
                ... state,
                crearDexitemLoading: true,
                crearDexitemLoaded: false,
                crearDexitemData: [],
                crearDexitemError: '',
            }
        case CREAR_ITEM_DEX_LOADED:
            return {
                ...state,
                crearDexitemLoading: false,
                crearDexitemLoaded: true,
                crearDexitemData: action.payload,
                dexItem: {
                    ...state.dexItem,
                    esp_comun: action.payload.esp_comun || state.dexItem?.esp_comun || [],
                    esp_pococomun: action.payload.esp_pococomun || state.dexItem?.esp_pococomun || [],
                    esp_raro: action.payload.esp_raro || state.dexItem?.esp_raro || [],
                },
                crearDexitemError: '',
            };
        case CREAR_ITEM_DEX_ERROR:
            return {
                ...state,
                crearDexitemLoading: false,
                crearDexitemLoaded: false,
                crearDexitemData:[],
                crearDexitemError: action.payload,
            }

        case DEX_UBICACIONES_LOADING:
            return {
                ... state,
                dexUbicacionesLoading: true,
                dexUbicacionesLoaded: false,
                dexUbicaciones: [],
                dexUbicacionesError: '',
            }
        case DEX_UBICACIONES_LOADED:
            return {
                ...state,
                dexUbicacionesLoading: false,
                dexUbicacionesLoaded: true,
                dexUbicaciones: action.payload,
                dexUbicacionesError: '',
            };
        case DEX_UBICACIONES_ERROR:
            return {
                ...state,
                dexUbicacionesLoading: false,
                dexUbicacionesLoaded: false,
                dexUbicaciones:[],
                dexUbicacionesError: action.payload,
            }

        case DEX_ITEM_LOADING:
            return {
                ... state,
                dexItemLoading: true,
                dexItemLoaded: false,
                dexItem: [],
                dexItemError: '',
            }
        case DEX_ITEM_LOADED:
            return {
                ...state,
                dexItemLoading: false,
                dexItemLoaded: true,
                dexItem: action.payload,
                dexItemError: '',
            };
        case DEX_ITEM_ERROR:
            return {
                ...state,
                dexItemLoading: false,
                dexItemLoaded: false,
                dexItem:[],
                dexItemError: action.payload,
            }

        case DEX_LOADING_DETAIL_HOME:
            return {
                ... state,
                dexHomeDetailLoading: true,
                dexHomeDetailLoaded: false,
                dexHomeDetailData: [],
                dexHomeDetailError: '',
            }
        case DEX_LOADED_DETAIL_HOME:
            return {
                ...state,
                dexHomeDetailLoading: false,
                dexHomeDetailLoaded: true,
                dexHomeDetailData: action.payload,
                dexHomeDetailError: '',
            };
        case DEX_ERROR_DETAIL_HOME:
            return {
                ...state,
                dexHomeDetailLoading: false,
                dexHomeDetailLoaded: false,
                dexHomeDetailData:[],
                dexHomeDetailError: action.payload,
            }

        case DEX_LOADING_HOME_SLIDER:
            return {
                ... state,
                dexHomeSliderLoading: true,
                dexHomeSliderLoaded: false,
                // dexHomeSliderData: [],
                dexHomeSliderError: '',
            }
        case DEX_LOADED_HOME_SLIDER:
            const { page, data } = action.payload;
            return {
                ...state,
                dexHomeSliderLoading: false,
                dexHomeSliderLoaded: true,
                dexHomeSliderError: "",
                dexHomeSliderPages: {
                ...state.dexHomeSliderPages,
                [page]: data, // 🔥 cache por página
                },
                dexHomeSliderData: data, // 🔥 página actual
            };
        case DEX_ERROR_HOME_SLIDER:
            return {
                ...state,
                dexHomeSliderLoading: false,
                dexHomeSliderLoaded: false,
                // dexHomeSliderData:[],
                dexHomeSliderError: action.payload,
            }

        case DEX_REFRESH_HOME_SLIDER:
            return {
                ...state,
                dexHomeSliderPages: {},
                dexHomeSliderData: [],
                dexHomeSliderLoading: false,
                dexHomeSliderError: "",
            };

        case DEX_LOADING_HOME:
            return {
                ... state,
                dexHomeLoading: true,
                dexHomeLoaded: false,
                dexHomeData: [],
                dexHomeError: '',
            }
        case DEX_LOADED_HOME:
            return {
                ...state,
                dexHomeLoading: false,
                dexHomeLoaded: true,
                dexHomeData: action.payload,
                dexHomeError: '',
            };
        case DEX_ERROR_HOME:
            return {
                ...state,
                dexHomeLoading: false,
                dexHomeLoaded: false,
                dexHomeData:[],
                dexHomeError: action.payload,
            }

        case DEX_LOADING:
            return {
                ... state,
                dexLoading: true,
                dexLoaded: false,
                dexData: [],
                dexError: '',
            }
        case DEX_LOADED:
            return {
                ...state,
                dexLoading: false,
                dexLoaded: true,
                dexData: action.payload,
                dexError: '',
            };
        case DEX_ERROR:
            return {
                ...state,
                dexLoading: false,
                dexLoaded: false,
                dexData:[],
                dexError: action.payload,
            }
        default: return state;
    }
}